import React from 'react';
import './PopupComponent.css';
import apple from '../../assets/images/apple-store-icon.png'

const ApplePopupComponent = ({ isModalOpenApple, onLoginClick }) => {
  if (!isModalOpenApple) return null;

  return (
    <div
      id="divMobileAppAlertApple"
      className="d-flex justify-content-center align-items-center popup-overlay"
    >
      <div className="popup-container">
        <div className="popup-header">
          <h2 className="popup-title">Download Inmate Mobile App</h2>
        </div>
        <div className="popup-body">
          <div className="form-group">  
            <p className="popup-message">
              Discover more, connect faster, and enjoy personalized benefits! Download our app today for seamless access to exclusive content,
              personalized recommendations, and convenient features tailored just for you.
            </p>
          </div>
          <div className="flex social-btns">
            <a
             style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              borderRadius: '5px',
            }}
              className="flex vert"
              href="https://apps.apple.com/us/app/inmate-inbox/id1390513826"
              target="_blank"
              rel="noopener noreferrer"
            >
            <img
            className='mb-1'  
              src={apple}
              alt="Google Play Logo"
              height={70}
            />
            </a>
          </div>
          <div className='mt-3' style={{ width: '100%', borderTop: '1px solid #507193' }}></div>
        </div>
        <div className="popup-footer">
          <button onClick={onLoginClick} className="btn btn-danger font-size-14 liner-button">
            SKIP
          </button>
        </div>
      </div>
    </div>
  );
};
 

export default ApplePopupComponent;
